import useMountEffect from '@restart/hooks/useMountEffect';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import EventEmitter from '@/libs/EventEmitter';

const useCustomTelemetryHandler = (robot) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    const subscribeToken = EventEmitter.subscribe(`${robot.id}/telemetry/mavlink`, clarifyMavLink);

    return () => {
      EventEmitter.unsubscribe(subscribeToken);
    };
  });

  const clarifyMavLink = ({ header, payload }) => {
    const msgId = header.msgid;

    switch (msgId) {
      case 1101: // USV_DATA
        updateRobotStatus(msgId, payload);
        break;
      default:
        break;
    }
  };

  const getKey = (msgId) => {
    switch (msgId) {
      case 1101:
        return 'usvData';
      default:
        return;
    }
  };

  const updateRobotStatus = (msgId, data) => {
    dispatch(actions.telemetry.set(robot.id, getKey(msgId), data));
  };
};

export default useCustomTelemetryHandler;
